import { PricingEngine } from '../../domain/pricing';
import type { ReceiptAddOnLine } from '../../domain/receipts/receiptTypes';

export function AddOnSelectionList({
  items,
  label = 'Selected add-ons',
}: {
  items: ReceiptAddOnLine[];
  label?: string;
}) {
  if (items.length === 0) return null;

  return (
    <div role="list" aria-label={label} className="space-y-2">
      {items.map((item) => (
        <div key={item.key} role="listitem" className="rounded-lg bg-[#DCEEFF] px-3 py-2">
          <p className="font-bold text-[#00549C]">
            {item.nameSnapshot} × {item.quantity}
          </p>
          {item.unitPriceCentavos !== undefined && (
            <p className="text-xs font-semibold text-slate-600">
              Unit price: {PricingEngine.formatCentavos(item.unitPriceCentavos)}
            </p>
          )}
          {item.lineTotalCentavos !== undefined && (
            <p className="text-xs font-bold text-slate-700">
              Subtotal: {PricingEngine.formatCentavos(item.lineTotalCentavos)}
            </p>
          )}
        </div>
      ))}
    </div>
  );
}
